module.exports = __webpack_public_path__ + "media/images/cedel2-cb25aea5b1d7535098ca5925da49cd1a.png";